import React, { useEffect, useState } from 'react'
import nbrApi from '../../services/nbrApi'
import { useSelector } from 'react-redux'
import { Table } from "react-bootstrap";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import ActiveRequestForMobile from './Requests/ActiveRequestForMobile';

function HousekeepingRequests() {
  let selectedLoginData = useSelector(state => state.auth.loginData)
  let userData = useSelector(state => state.auth.userData)
  let selectedData = userData?.filter(e =>
    e?.properties_id === parseInt(selectedLoginData.properties_id) &&
    e?.roles_id === Number(selectedLoginData.role_id))?.[0]

  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const [reason, setReason] = useState('');

  // get requests
  const getActiveRequests = async () => {
    try {
      const responseRequestsData = await nbrApi.get(
        `/gethkrequestsnotcompleted?p_id=${selectedData?.properties_id}&re_id=${selectedData?.resources_id}`,
      )
      let responseRequests = responseRequestsData?.data
      console.log(responseRequests)
      let no_field_count = Array.isArray(responseRequests) ?
        (responseRequests?.length > 0 ?
          (responseRequests[0]?.fieldCount === 0 ? false : true) : false) : false;

      if (responseRequests) {
        if (!no_field_count) {
          setData([])
          return
        } else {
          setData(responseRequests)
        }
        // console.log(responseRequests)
      }
    } catch {
      setData([])
    }
  }

  useEffect(() => {
    if (selectedLoginData && selectedData) {
      // console.log(selectedLoginData)
      setTimeout(() => {
        getActiveRequests()
      }, 5000)
    }
  }, [selectedData, selectedLoginData])

  // handle status
  const handleActionStatus = async (param) => {
    try {
      setIsLoading(true)
      const responseChangeData = await nbrApi.get(`/respondtorequest?p_id=${selectedData?.properties_id}&hkrq_id=${data?.[0]?.hkrq_id}&hkrc_id=${param === 'accept' ? 1 : 3
      }&re_id=${selectedData?.resources_id}`)
      if (responseChangeData?.data) {
        // Swal.fire('Request ' + (param === 'accept' ? ' Accepted' : ' Rejected'))
        // success
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Request ' + (param === 'accept' ? ' Accepted' : ' Rejected'),
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          navigate('/accepted-task/' + data[0]?.hkrq_id)
        })
        setIsLoading(false)
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Unknown error',
        });
        setIsLoading(false)

      }
    } catch {
      setIsLoading(false)

      setData([])
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Failed !',
      });
    }
  }

  const handleDelete = () => {
    // Create a textarea element
    const textarea = document.createElement('textarea');
    textarea.placeholder = "Type your reason here";
    textarea.style.width = '100%';
    textarea.style.height = '100px';
    textarea.className = 'form-control';

    Swal.fire({
      title: "Are you sure?",
      text: "Once Rejected, you will not be able to accept this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      html: textarea.outerHTML,
      preConfirm: () => {
        return document.querySelector('textarea').value;
      }
    }).then((value) => {
      if (value.isConfirmed) {
        setReason(document.querySelector('textarea').value);
        handleActionStatus('reject');
      }
    });
  };
  // render
  return (
    <div className="row">
      <div className="col-xxl-12">
        <div className="card">
          <div className="card-header">
            <h4 className="heading me-2">Active Requests</h4>
          </div>

          <div className="card-body">
            {data?.length === 0 &&
              <p className='alert alert-primary fw-bold'>No Request available !</p>}

            {data?.length > 0 &&
              <>
                <Table responsive className="w-100 d-none d-lg-block">
                  <div id="example_wrapper" className="dataTables_wrapper">
                    <table
                      id="example"
                      className="display w-100 dataTable"
                      role="grid"
                      aria-describedby="example_info"
                    >
                      <thead>
                        <th>ID</th>
                        <th>REQUEST SUMMARY	</th>
                        <th>TRACKING LEVEL	</th>
                        <th>STATUS</th>
                      </thead>
                      <tbody>
                        {data?.slice(0, 1).map((d, i) => (
                          <tr key={i} className='text-black text-capitalize'>
                            <td key={i}>{'#' + d.hkrq_id}</td>
                            <td key={i}>{d.request_summary}</td>
                            <td key={i}>{d.tracking_level}</td>
                            <td key={i}><span className='badge badge-secondary'>{d.status_val}</span></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Table>
                <div className='d-block d-lg-none'>
                  <ActiveRequestForMobile data={data} />
                </div>
                <div className='text-center mt-3'>
                  <button type='button' disabled={isLoading} onClick={() => handleActionStatus('accept')} className='btn btn-sm btn-primary'>Accept</button>
                  <button type='button' disabled={isLoading} onClick={handleDelete} className='mx-2 btn btn-sm btn-danger'>Reject</button>
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default HousekeepingRequests